import timeZoneCityToCountryStatic from './timeZoneCityToCountry.json';
// Import { countries, zones } from 'moment-timezone/data/meta/latest.json';

interface LocationData {
  timezone: string;
  region: string;
  city: string;
  country: string;
}

const timeZoneCityToCountry: Record<string, string> =
  timeZoneCityToCountryStatic;

/**
 * Info: For optimized bundle size, the mapped timeZoneCityToCountry saved as json
 *
 * // Populate the dictionary
 *Object.keys(zones).forEach((z) => {
 *const cityArr = z.split('/');
 *const city = cityArr[cityArr.length - 1];
 *timeZoneCityToCountry[city] =
 *  countries[
 *    zones[z as keyof typeof zones].countries[0] as keyof typeof countries
 *  ].name;
 *});
 *
 */

export default function getUserLocation(): LocationData {
  let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (userTimeZone === 'Asia/Bangkok') userTimeZone = 'Asia/Jakarta';
  const [userRegion, ...cityParts] = userTimeZone.split('/');
  const userCity = cityParts.join('/'); // Join remaining parts for cities like "New York"

  return {
    timezone: userTimeZone,
    region: userRegion,
    city: userCity,
    country: timeZoneCityToCountry[userCity] || 'Unknown', // Handle missing cities
  };
}
